
module.exports = (typeof WeakMap !== 'undefined') ? WeakMap : require("weak-map");



//////////////////
// WEBPACK FOOTER
// ./node_modules/collections/weak-map.js
// module id = 112
// module chunks = 0